document.addEventListener('click', event => {

  const menu = event.target.closest('.studio-menu-toggle');

  if (menu) { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); document.getElementById(menu.getAttribute('aria-controls'))?.classList.toggle('is-open', open); }

  const quantity = event.target.closest('[data-quantity]');

  if (quantity) { const form = quantity.closest('form'); const input = form.querySelector('[data-quantity-input]'); const value = Math.max(1, Math.min(99, Number(input.value) + Number(quantity.dataset.quantity))); input.value = value; form.querySelector('[data-quantity-value]').textContent = value; }

  const gallery = event.target.closest('[data-gallery-image]');

  if (gallery) { const section = gallery.closest('[data-product-section]'); const img = section.querySelector('[data-product-media] img'); if (img) { img.removeAttribute('srcset'); img.src = gallery.dataset.galleryImage; } }

});

document.addEventListener('change', async event => {

  if (event.target.matches('[data-collection-sort]')) event.target.form.requestSubmit();

  const form = event.target.closest('[data-product-form]'); if (!form) return;

  const section = form.closest('[data-product-section]');

  const preview = section.querySelector('pet-preview');

  if (event.target.matches('[data-product-variant]')) {

    const variant = event.target.selectedOptions[0];

    section.querySelector('[data-product-price]').textContent = variant.dataset.price;

    if (preview) preview.setAttribute('shape', variant.dataset.shape);

    const available = variant.dataset.available === 'true'; const submit = form.querySelector('[data-product-submit]'); submit.disabled = !available; submit.querySelector('[data-submit-label]').textContent = available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;

  }

  if (event.target.matches('[data-pet-background]') && preview) preview.setAttribute('background', event.target.value);

  if (event.target.matches('[data-pet-photo]') && !event.target.hasAttribute('data-keychain-photo')) {

    const file = event.target.files[0]; if (!file) return;

    if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) { event.target.value = ''; window.alert(event.target.dataset.error); return; }

    const url = URL.createObjectURL(file);

    try { const image = new Image(); image.src = url; await image.decode(); } catch { URL.revokeObjectURL(url); event.target.value = ''; window.alert(event.target.dataset.error); return; }

    if (preview) { if (preview.dataset.photoUrl) URL.revokeObjectURL(preview.dataset.photoUrl); preview.dataset.photoUrl = url; preview.setAttribute('photo', url); preview.setAttribute('pet-name', form.querySelector('[data-pet-name]').value); }

    form.querySelector('[data-photo-status]').textContent = file.name;

    section.querySelector('.studio-preview-label')?.remove();

  }

});

document.addEventListener('input', event => { if (event.target.matches('[data-pet-name]')) event.target.closest('[data-product-section]').querySelector('pet-preview')?.setAttribute('pet-name', event.target.value); });

